import * as Sentry from "@sentry/react";

const isProduction = import.meta.env.MODE === 'production';

Sentry.init({
  dsn: "https://4ea9b74c665f48e9e094bc76d383014c@o4509447138967552.ingest.de.sentry.io/4509447205290064",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Performance monitoring
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0, // Lower sampling in production
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Session replay
  replaysSessionSampleRate: 0.1, // Capture 10% of sessions for replays
  replaysOnErrorSampleRate: 1.0, // Capture replays for all errors
  environment: import.meta.env.MODE,
  tracePropagationTargets: ["localhost", /^https:\/\/studio-redux.spechops\.com\/api/]
});

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { twMerge } from 'tailwind-merge'
import { ThemeProvider } from '@/components/UIUX/theme-provider'
import { replaceDarkWithDataThemeDark } from '@/utils/themeConverter'
import { initializeTheme } from '@/utils/themeUtils'
import App from './App'
import 'font-awesome/css/font-awesome.min.css'
import './tailwind.css' // Built Tailwind CSS file

initializeTheme()

createRoot(document.getElementById('root')!).render(
  <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
    <StrictMode>
      <App />
    </StrictMode>
  </ThemeProvider>
)
